<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Consulta de espelhos de ponto</div>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label>Usuário</label>
              <select class="form-control" v-model="search.user_id">
                <option :value="user.id" v-for="user in users" :key="user.id">
                  {{ user.name }}
                </option>
              </select>
            </div>
          </div>
           <div class="col-md-2">
            <div class="form-group">
              <label>Ação</label>
              <button
                class="btn btn-block btn-info"
                @click="searchMirror"
                :disabled="!search.user_id"
              >
                Buscar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="row">
          <table class="table table-striped table-bordered">
              <thead>
                <th scope="col">Período</th>
                <th scope="col">Início Período</th>
                <th scope="col">Fim Período</th>
                <th scope="col">Jornada</th>
                <th scope="col">Feriados no Período</th>
                <th scope="col">Dias Úteis</th>
                <th scope="col">Total à Trabalhar</th>
                <th scope="col">Total Trabalhado</th>
                <th scope="col">Banco de Horas no Período</th>
                <th scope="col">Ações</th>
              </thead>
              <tbody>
                <tr v-for="mirror in mirrors" :key="mirror.id">
                  <td>
                    {{ mirror.period_f }}
                  </td>
                  <td>{{ mirror.start_period }}</td>
                  <td>{{ mirror.end_period }}</td>
                  <td>{{ mirror.journey.title }}</td>
                  <td>{{ mirror.holidays }}</td>
                  <td>{{ mirror.usefull_days }}</td>
                  <td>{{ mirror.total_working }}</td>
                  <td>{{ mirror.total_worked }}</td>
                  <td>{{ mirror.bank_of_hours }}</td>
                  <td>
                   
                  </td>
                </tr>
                <tr>
                  <td v-if="mirrors.length == 0" colspan="9" align="center">
                    Nenhum registro encontrado.
                  </td>
                </tr>
              </tbody>
            </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        users: [],
        search: {
            user_id: 0
        },
        mirrors: []
    };
  },
  mounted() {

    this.getUsers();
  },
  methods: {
    isNegative(value){
        return value.includes('-')
    },
    isPositive(value){
        return !value.includes('-')
    },
    searchMirror(){
        let api = this.$store.getters.api + "point-mirror-consult?user_id= " + this.search.user_id;
        let self = this;

        self.$http.get(api).then((response) => {
            console.log(response.data);
            self.mirrors = response.data;
        });
    },
    getUsers: function () {
      const self = this;
      const api = this.$store.state.api + "users?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/PointMirror/Consult.vue